module.exports = __webpack_public_path__ + "static/media/form-right.8bc3364d.png";